import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { baseApi } from "../services/rtkApi/baseApi";
import { authServiceApi } from "../services/rtkApi/authServiceApi";
import { adminApi } from "../services/rtkApi/adminApi";
import { messengerApi } from "../services/rtkApi/messengerApi";

// slices
import authReducer from "./slices/authSlice";
import chatUiReducer from "./slices/chatUiSlice";

export const store = configureStore({
  reducer: {
    // rtk query apis
    [baseApi.reducerPath]: baseApi.reducer,
    [authServiceApi.reducerPath]: authServiceApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [messengerApi.reducerPath]: messengerApi.reducer,
    // slices
    auth: authReducer,
    chatUi: chatUiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(baseApi.middleware)
      .concat(authServiceApi.middleware)
      .concat(adminApi.middleware)
      .concat(messengerApi.middleware),
});

// Enable RTK Query's `refetchOnFocus` / `refetchOnReconnect` app-wide. Without
// this, every endpoint's focus refetch is a silent no-op (the hand-summary poll
// in P4 and DropLiveCta's existing focus refetch both depend on it).
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
